<via-loading-spinner *ngIf="isLoading"></via-loading-spinner>
<div
    *ngIf="dataSource.data.length > 0; else showNoResults"
    class="e-results-table-container"
    infinite-scroll
    [infiniteScrollDistance]="0.1"
    (scrolled)="onScrollDown()"
    [scrollWindow]="false"
    id="scrollElement">
    <table mat-table [dataSource]="dataSource">
        <ng-container matColumnDef="skuDetails">
            <th mat-header-cell *matHeaderCellDef class="e-col-sku-details">SKU Details</th>
            <td mat-cell *matCellDef="let element" class="e-col-sku-details">
                <!-- <via-feedback-flag [feedbackReviewPending]="element.feedbackReviewPending" (submitFeedback)="onSubmitFeedback($event)">
                </via-feedback-flag> -->
                <div
                    (click)="getSkuCapsule(element)"
                    role="button"
                    aria-label="View SKU capsule details"
                    class="e-sku-details-container"
                    tabindex="0">
                    <div class="e-sku-thumbnail">
                        <img
                            [id]="element.id"
                            [src]="element.emiImageUrl !== '' ? blobStorageUrl + element.emiImageUrl + imageSasParams : noImagePlaceholderUrl"
                            alt="SKU thumbnail"
                            (error)="handleMissingImage(element.id)" />
                    </div>
                    <div class="e-sku-details">
                        <h5 class="e-sku-name">{{ element.name }}</h5>
                        <span>
                            Country: {{ element.country.name }} | Industry: {{ element.category.name }}
                            <ng-container *ngIf="element.retailer"> | Retailer: {{ element.retailer.name }}</ng-container>
                        </span>
                        <span>
                            Category: {{ getLevelOneCategoryDetails(element)?.name }}
                            <ng-container *ngIf="getSubCategory(element)"> | Sub-Category: {{ getSubCategory(element)?.name }}</ng-container
                            ><br />
                        </span>
                        <span>
                            <ng-container *ngIf="element.supplier"
                                >Supplier: {{ element.supplier.name }} | Brand: {{ element.brand.brandName }}</ng-container
                            >
                            <ng-container *ngIf="element.brand.subBrandId"> | Sub-Brand: {{ element.brand.subBrandName }}</ng-container>
                        </span>
                        <span>
                            <ng-container *ngIf="getPackSize(element)">Pack Size: {{ getPackSize(element)?.measure }} |</ng-container>
                            Unit Per Pack: {{ getUnitPerPack(element)?.measure }}
                            <ng-container *ngIf="getUnitSize(element)"> | Total Size: {{ getUnitSizeText(element) }}</ng-container>
                        </span>
                    </div>
                </div>
            </td>
        </ng-container>

        <ng-container matColumnDef="totalSkuSize">
            <th mat-header-cell *matHeaderCellDef class="e-col-sku-size">
                Total<br />SKU Size<via-info-icon [tooltipText]="totalSkuSizeTooltip"></via-info-icon>
            </th>
            <td mat-cell *matCellDef="let element" class="e-col-sku-size">{{ getTotalSKUSize(element) }}</td>
        </ng-container>

        <ng-container matColumnDef="lastSeenPrice">
            <th mat-header-cell *matHeaderCellDef class="e-col-last-price">Last Seen Price</th>
            <td mat-cell *matCellDef="let element" class="e-col-last-price">
                {{ element.pricingStats.lastSeenPrice ? element.pricingStats.lastSeenPrice.toFixed(2) : 'N/A' }}
            </td>
        </ng-container>

        <!-- <ng-container matColumnDef="select">
            <th mat-header-cell *matHeaderCellDef class="e-col-select">
                <mat-checkbox (change)="$event ? masterToggle() : null" [checked]="selection.hasValue() && isAllSelected()"
                    [indeterminate]="selection.hasValue() && !isAllSelected()" [aria-label]="checkboxLabel()">
                    {{checkboxLabel()}}
                </mat-checkbox>
            </th>
            <td mat-cell *matCellDef="let element" class="e-col-select">
                <mat-checkbox (click)="$event.stopPropagation()" (change)="$event ? selection.toggle(element) : null"
                    [checked]="selection.isSelected(element)" [aria-label]="checkboxLabel(element)">
                    {{checkboxLabel(element)}}
                </mat-checkbox>
                <button class="e-remove-sku-button" [attr.aria-label]="removeSkuTooltipText" matTooltipClass="e-mat-tooltip"
                    matTooltipPosition="below" matTooltip="{{removeSkuTooltipText}}" matTooltipShowDelay="500"
                    (click)="deleteItemFromList(element.id)">
                    <i class="fas fa-times"></i>
                </button>
            </td>
        </ng-container> -->

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
    </table>
</div>

<ng-template #showNoResults>
    <div class="e-no-results" *ngIf="!isLoading">
        <i class="fa-search far"></i>
        <h1>NO SEARCH RESULTS</h1>
        <p>
            There are no SKUs that match your search term. <br />
            Please refine and search again.
        </p>
    </div>
</ng-template>
